import { Expected } from './Expected';
export function isDiscourseExpected(discourse) {
    return discourse !== null && typeof discourse === 'object' && discourse instanceof Expected;
}
export {
    isDiscourseExpected as isExpected
};
export default isDiscourseExpected;    //# sourceMappingURL=isExpected.js.map
